module.exports = __webpack_public_path__ + "assets/img/txt-mv.e2597354.svg";